import type {
  EnrollmentTargetRow,
  TargetDraft,
  TrackedTarget,
  UpsertTargetPayload,
} from "./enrollmentTarget.types";

export const ENROLLMENT_TARGETS_DATASET_TYPE = "enrollment-targets";

export function mapTargetRowToTrackedTarget(
  row: EnrollmentTargetRow,
): TrackedTarget {
  return {
    // The API stores the first of the month (e.g. "2026-03-01"); the table/modal/chart
    // all key on the "YYYY-MM" month string.
    month: row.month.slice(0, 7),
    sponsorPlan: row.sponsor_plan,
    changedBy: row.last_modified_by_name,
    changedAt: row.last_modified_at,
    rationale: row.rationale,
  };
}

export function buildUpsertPayload(draft: TargetDraft): UpsertTargetPayload {
  return {
    month: `${draft.month}-01`,
    sponsor_plan: draft.sponsorPlan,
    rationale: draft.rationale,
  };
}

/** A cumulative total that falls month over month is always a data-entry mistake. */
export function computeDecreasingMonths(targets: TrackedTarget[]): string[] {
  const sorted = [...targets].sort((a, b) => a.month.localeCompare(b.month));
  const decreasing: string[] = [];
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i].sponsorPlan < sorted[i - 1].sponsorPlan) {
      decreasing.push(sorted[i].month);
    }
  }
  return decreasing;
}
